import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-my-course-index-route.tsx
var LazyMyCourseIndexRoute = lazy(() => import("./my-course-index-route-PBo4TwEZ.js").then((n) => n.n).then((module) => ({ default: module.MyCourseIndexRoute })));
function MyCourseIndexRoute({ route, ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "index-route" }),
		children: /* @__PURE__ */ jsx(LazyMyCourseIndexRoute, {
			route,
			...props
		})
	});
}
var useMyCourseIndexRoute = () => {
	return useMemo(() => ({ "my-courses-index-route": { component: MyCourseIndexRoute } }), []);
};
//#endregion
export { useMyCourseIndexRoute };
